import { OutcomeDto } from '@bz/request/src/apis';
import { useSocketBusiness } from '@bz/socket';
import { createDerivedStaticStore } from '@solid-primitives/static-store';

import { access, MaybeAccessor } from '~/utils/type.utils';

export const createLatestOdds = <
  T extends Pick<OutcomeDto, 'code' | 'odds' | 'active'> &
    Partial<Omit<OutcomeDto, 'code'>> & {
      odds?: number;
      active?: number;
      marketStatus?: number;
    } & {
      marketName?: string;
    },
>(
  odds: MaybeAccessor<T>
): T & {
  odds: number;
  active: number;
  diff: number;
  marketName?: string;
  colName?: string;
} => {
  const { useOddWS } = useSocketBusiness();

  const oddsWs = useOddWS(() => access(odds).code);

  /**
   * https://primitives.solidjs.community/package/static-store/#createderivedstaticstore
   * 这里用deriveStaticStore 封装成一个getter（内部实现会对每个值做一个equals check），实现下游的最小化的更新
   */
  // 这个地方实现了对原始赔率数据的增强，结合了WebSocket推送的最新赔率信息，实现了赔率数据的实时更新
  const oddsStore = createDerivedStaticStore((prev: T | undefined) => {
    const originOdds = access(odds);
    const ws = oddsWs();
    return {
      ...originOdds,
      __INTERNAL_DEBUG_ODDS_WS: ws,
      odds: ws?.value ?? originOdds.odds,
      active: ws?.status ?? originOdds.active,
      marketStatus: ws?.marketStatus ?? originOdds.marketStatus,
      diff: ws?.value ? ws.value - (prev?.odds ?? originOdds.odds) : 0,
    } satisfies T;
  });

  return oddsStore;
};
